import { useEffect, useState } from "react";

const MOBILE_MEDIA_QUERY = "(max-width: 1024px)";

/**
 * Resolves mobile viewport for toast layout when `isMobile` prop is not provided.
 *
 * @param {boolean|undefined} isMobileProp
 * @returns {boolean|undefined}
 */
const useToastViewport = (isMobileProp) => {
  const [isMobileViewport, setIsMobileViewport] = useState(undefined);

  useEffect(() => {
    if (typeof isMobileProp === "boolean") {
      return undefined;
    }

    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);

    /**
     * Syncs toast viewport state with the current mobile media query match.
     *
     * @returns {void}
     */
    const updateViewport = () => setIsMobileViewport(mediaQuery.matches);

    updateViewport();
    mediaQuery.addEventListener("change", updateViewport);

    return () => mediaQuery.removeEventListener("change", updateViewport);
  }, [isMobileProp]);

  return typeof isMobileProp === "boolean" ? isMobileProp : isMobileViewport;
};

export default useToastViewport;
